"use strict";

exports.__esModule = true;
exports.ONE_APP_VERSIONS = void 0;
var ONE_APP_VERSIONS = {
  IMAGE_UPLOAD: '2.762.0',
  LINKS: '2.2071.0',
  SHARE: '2.1895.0'
};
exports.ONE_APP_VERSIONS = ONE_APP_VERSIONS;